// extracted by css-extract-rspack-plugin
export default {"cellSub":"cellSub-saTlKy","coverageRequirementsCount":"coverageRequirementsCount-R7JEUt","requirementIcon":"requirementIcon-hANWET","statusColumn":"statusColumn-iIw4Sp"};